import { Auslandsrisikoort, Risikoort } from '@ps20-frontend/frontend-models';
import { GebaeudeArtKdv, HausArt, Stockwerk } from '@ps20/bff-models';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';

export const VN_ADRESSE_ID = 'VN_ADRESSE_ID';

export interface Immobilie {
  id: string;
  risikoort: Risikoort | Auslandsrisikoort;
  wohnflaeche: number;
  baujahr: number;
  ausgewaehlt: boolean;
  kellerVorhanden: boolean;
  kellerMitWohnflaeche: boolean;
  flachdach: boolean;
  ferienhaus: boolean;
  nebengebaeudeVorhanden: boolean;
  nebengebaeudeQM: number;
  oeltank: boolean;
  gebaeudeArtKdv: GebaeudeArtKdv;
  stockwerk?: Stockwerk;
  wohnungsnr?: string;
  hausart?: HausArt;
  staendigBewohnt?: boolean;
  hasElementar?: boolean;
}

export interface ImmobilieFormatted {
  usedInOtherAngebot: boolean;
  immoId: string;
  formattedString: string;
  disabled: boolean;
}

export const isEqualForRelevantFields = function (
  adresseVn: Risikoort,
  adresse: Risikoort,
): boolean {
  if (!adresseVn || !adresse) {
    return false;
  }
  const deepcopyAdresseVn: Risikoort = cloneDeep(adresseVn);
  delete deepcopyAdresseVn.ortsteil;
  delete deepcopyAdresseVn.hausnrzus;
  delete deepcopyAdresseVn.land;
  delete deepcopyAdresseVn.status;
  delete adresse.ortsteil;
  delete adresse.hausnrzus;
  delete adresse.land;
  delete adresse.status;

  return isEqual(deepcopyAdresseVn, adresse);
};
